var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebTraffic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_18653_126152)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18653_126152",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 26,
    height: 26
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.3,
    y: -0.3,
    width: 24.6,
    height: 24.6,
    fill: "#D9D9D9",
    stroke: "white",
    strokeWidth: 0.6
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18653_126152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8457 9.98535L10.9688 10.0117L10.9824 10.0156L17.0312 11.9229L17.0391 11.9258L17.0479 11.9287C17.1872 11.982 17.3067 12.0713 17.3916 12.1992L17.4424 12.2881C17.4869 12.3797 17.5117 12.4797 17.5117 12.5859C17.5117 12.6832 17.4933 12.7769 17.458 12.8652L17.417 12.9512C17.339 13.0939 17.2154 13.1887 17.0732 13.2432L17.0713 13.2441L15.416 13.8672L19.1318 17.584L19.207 17.666C19.3729 17.8625 19.4658 18.0938 19.4658 18.3535C19.4658 18.6133 19.3729 18.8444 19.207 19.041L19.1318 19.123L18.9121 19.3428C18.7107 19.5441 18.4631 19.6572 18.1807 19.6572C17.9336 19.6571 17.7134 19.5706 17.5273 19.4141L17.4502 19.3428L13.6768 15.5693L13.0713 17.1943V17.1973C13.0153 17.3436 12.9159 17.4673 12.7695 17.5439C12.6565 17.603 12.5334 17.6357 12.4043 17.6357C12.2672 17.6357 12.1394 17.596 12.0254 17.5254V17.5264C11.8918 17.444 11.8008 17.3221 11.7471 17.1816L11.7441 17.1738L11.7412 17.165L9.84277 11.1553L9.83887 11.1416C9.79602 10.9783 9.7854 10.81 9.83008 10.6484L9.87012 10.5361C9.91769 10.4275 9.98779 10.3306 10.0732 10.2451L10.1621 10.165C10.255 10.0911 10.3596 10.0352 10.4756 10.0029H10.4766L10.5986 9.97949C10.6805 9.97029 10.7634 9.97275 10.8457 9.98535ZM7.18164 14.7441C7.40655 14.7623 7.6022 14.8711 7.7627 15.0371L7.82812 15.1094C7.95287 15.2567 8.03249 15.4273 8.0498 15.6182L8.05371 15.7148C8.04923 15.9408 7.96281 16.1411 7.81836 16.3105L7.75293 16.3809L6.55664 17.5771C6.40168 17.7321 6.21676 17.8346 6.00586 17.8643L5.91406 17.8721C5.65104 17.8825 5.42294 17.7715 5.23828 17.5869V17.5859C5.04731 17.4012 4.93256 17.1713 4.9375 16.9043C4.94238 16.6443 5.05338 16.4181 5.23828 16.2334L6.43457 15.0371L6.50293 14.9736C6.66754 14.8335 6.86246 14.7508 7.08203 14.7422L7.18164 14.7441ZM4.75 10.75C5.00911 10.75 5.23877 10.845 5.42188 11.0283L5.48633 11.0986C5.62734 11.2687 5.70011 11.4726 5.7002 11.6992C5.7002 11.926 5.62748 12.1306 5.48633 12.3008L5.42188 12.3711C5.23879 12.5544 5.00906 12.6494 4.75 12.6494H3.05078C2.82395 12.6494 2.61941 12.5767 2.44922 12.4355L2.37891 12.3711C2.19565 12.188 2.10059 11.9583 2.10059 11.6992C2.10068 11.4404 2.1958 11.2113 2.37891 11.0283L2.44922 10.9639C2.61943 10.8227 2.82391 10.75 3.05078 10.75H4.75ZM5.98633 4.95312C6.20456 4.98049 6.39606 5.08668 6.55664 5.24707L7.75293 6.44336L7.81641 6.51172C7.95576 6.67509 8.03937 6.86792 8.04785 7.08594L8.04688 7.18262C8.03026 7.40288 7.92547 7.59517 7.7666 7.75586L7.76758 7.75684C7.60517 7.92667 7.40706 8.03706 7.17969 8.05859L7.08008 8.0625C6.85249 8.05823 6.65104 7.97236 6.48047 7.82715L6.40918 7.76172L5.21289 6.56543C5.05704 6.4095 4.95533 6.22294 4.92578 6.01074L4.91797 5.91797C4.90897 5.68213 4.99765 5.47529 5.14941 5.30371L5.21777 5.23242C5.40261 5.04961 5.62986 4.94137 5.89062 4.94629L5.98633 4.95312ZM16.5137 4.93652C16.7717 4.93652 16.9954 5.04896 17.1777 5.23145L17.2451 5.30469C17.3727 5.45419 17.4563 5.62694 17.4746 5.82031L17.4785 5.91895C17.4735 6.1802 17.3545 6.40335 17.166 6.58496L17.167 6.58594L15.9805 7.7627L15.9766 7.7666C15.7951 7.93955 15.578 8.04662 15.3301 8.05664L15.3291 8.05762C15.0612 8.06797 14.8315 7.94828 14.6484 7.75684V7.75586C14.4662 7.57109 14.3584 7.34435 14.3633 7.08398L14.3701 6.98926C14.3973 6.77072 14.5024 6.57864 14.6631 6.41797L15.8496 5.23145L15.9199 5.16699C16.0885 5.02295 16.2878 4.93658 16.5137 4.93652ZM11.5078 3.2998C11.7669 3.2998 11.9966 3.39485 12.1797 3.57812L12.2441 3.64844C12.3853 3.81862 12.458 4.02319 12.458 4.25V5.94922C12.458 6.17603 12.3853 6.3806 12.2441 6.55078L12.1797 6.62109C11.9966 6.80437 11.7669 6.89941 11.5078 6.89941C11.2812 6.89934 11.0774 6.82647 10.9072 6.68555L10.8359 6.62109C10.653 6.43799 10.5586 6.20811 10.5586 5.94922V4.25C10.5586 3.99111 10.653 3.76123 10.8359 3.57812L10.9072 3.51367C11.0774 3.37275 11.2812 3.29987 11.5078 3.2998Z",
    fill: "#587E85",
    stroke: "white",
    strokeWidth: 0.6
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_18653_126152",
    x: 1.80029,
    y: 2.99951,
    width: 17.9653,
    height: 18.1578,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18653_126152"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_18653_126152",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebTraffic);
export default __webpack_public_path__ + "static/media/web_traffic.cef9fe388ef0274affff676b60adf020.svg";
export { ForwardRef as ReactComponent };